import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from './translations';
import { defaultLocale, getLocaleFromPath, supportedLocales } from './routing';

const initialLocale =
  typeof window === 'undefined'
    ? defaultLocale
    : getLocaleFromPath(window.location.pathname);

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: initialLocale,
    fallbackLng: defaultLocale,
    supportedLngs: supportedLocales,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
